/**
 * Integrytas Base App · MOBILE primitive
 * Filter chips (Direction C) — a pill-shaped, horizontally-wrapping filter row.
 * Generic over selection: pass `isActive` so it works for single-select
 * (v === current) or multi-select facets (selected.includes(v)).
 */
export interface MobileChip {
  value: string;
  label: string;
}

interface MobileFilterChipsProps {
  chips: MobileChip[];
  isActive: (value: string) => boolean;
  onSelect: (value: string) => void;
}

export function MobileFilterChips({ chips, isActive, onSelect }: MobileFilterChipsProps) {
  return (
    <div className="m-chips">
      {chips.map((c) => (
        <button
          key={c.value}
          type="button"
          className={'m-chip' + (isActive(c.value) ? ' m-active' : '')}
          onClick={() => onSelect(c.value)}
        >
          {c.label}
        </button>
      ))}
    </div>
  );
}
